"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isChinaMobile = exports.isAEM = undefined;

var _ramda = require("ramda");

var isAEM = exports.isAEM = function isAEM(props) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ["parent"];
  return (0, _ramda.pathOr)(false, path, props) === "aem";
};
var isChinaMobile = exports.isChinaMobile = function isChinaMobile(country) {
  return country === "cn";
};